<div class="assistant-widget">
  <button class="assistant-bouton" (click)="basculerOuverture()" [class.ouvert]="ouvert">
    {{ ouvert ? '✕' : '✦' }}
  </button>

  <div class="assistant-panneau" *ngIf="ouvert">
    <div class="assistant-header">
      <strong>Assistant du Festival</strong>
      <span>Réponses basées sur les données en direct</span>
    </div>

    <div class="assistant-messages">
      <div class="message" *ngFor="let m of messages" [ngClass]="m.auteur">
        <p style="white-space: pre-line;">{{ m.texte }}</p>
      </div>
    </div>

    <div class="assistant-suggestions" *ngIf="messages.length <= 1">
      <button *ngFor="let s of suggestions" (click)="envoyerSuggestion(s)">{{ s }}</button>
    </div>

    <div class="assistant-saisie">
      <input type="text" [(ngModel)]="saisie" placeholder="Posez votre question..."
             (keyup.enter)="envoyerMessage()">
      <button (click)="envoyerMessage()">➤</button>
    </div>
  </div>
</div>
